import PropTypes from 'prop-types';
import './withToolTip.css';

const withToolTip = (toolTip, toolTipPosition) =>
  toolTip && {
    'aria-label': toolTip,
    'data-tooltip-position': toolTipPosition || 'right'
  };

withToolTip.propTypes = {
  toolTip: PropTypes.string,
  toolTipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
};

withToolTip.defaultProps = {
  toolTip: undefined,
  toolTipPosition: 'right'
};

export default withToolTip;
